import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import {
  deleteEntity as deleteManufacturerAction,
  editEntity as editManufacturerAction,
} from '../../../redux/actions/manufacturersActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';

export default function ManufacturerEdit({
  open,
  handleClose,
  manufacturerToEdit,
}) {
  const dispatch: any = useDispatch();

  const [status, setStatus] = useState(manufacturerToEdit.status);
  const handleCloseAction = () => {
    handleClose();
  };

  const onClickSaveEquipmentCategory = async () => {
    const response: any = await dispatch(
      editManufacturerAction({ id: manufacturerToEdit.id, status: !!status }),
    );
    if (response?.status === 200) {
      dispatch(snackbarShowMessage('manufacturer.edit.messages.updateSuccess'));
    }
    handleCloseAction();
  };

  const onInputSelectChange = event => {
    setStatus(event.target.value);
  };

  const handleDelete = async () => {
    const response: any = await dispatch(
      deleteManufacturerAction(manufacturerToEdit.id),
    );
    if (response.status === 200) {
      dispatch(
        snackbarShowMessage(`Manufacturer ${manufacturerToEdit.name} deleted`),
      );
    } else {
      dispatch(
        snackbarShowMessage(`Error on delete ${manufacturerToEdit.name}`),
      );
    }
    handleClose();
  };

  const { t } = useTranslation();

  const statusOptions = [
    { name: t('app.common.All'), value: '' },
    { name: t('app.common.active'), value: 1 },
    { name: t('app.common.inactive'), value: 0 },
  ];

  const manufacturerStrings = {
    id: t('app.common.id'),
    status: t('app.common.status'),
    manufacturer_name: t('createManufacturer.manufacturerName'),
    active: t('app.common.active'),
    inactive: t('app.common.inactive'),
    not_manufacturer_found: t('createManufacturer.noManufacturerFound'),
    create_manufacturer: t('createManufacturer.createManufacturer'),
    edit_manufacturer: t('createManufacturer.editManufacturer'),
    new_manufacturer: t('createManufacturer.newManufacturer'),
    manufacturer: t('createManufacturer.manufacturer'),
    cancel: t('app.common.cancel'),
    add_to_catalog: t('createManufacturer.addToCatalog'),
    activate: t('createManufacturer.activate'),
    inactivate: t('createManufacturer.inactivate'),
    save: t('app.common.save'),
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseAction}
      aria-labelledby="form-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle id="form-dialog-title">
        {manufacturerStrings.edit_manufacturer}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          id="name"
          label={manufacturerStrings.manufacturer}
          variant="outlined"
          autoComplete="off"
          size="small"
          value={manufacturerToEdit.name}
          disabled
        />
        <Select
          label={t('app.common.country')}
          inputProps={{
            name: 'country',
            id: 'search-type',
            size: 'small',
          }}
          value={status}
          onChange={onInputSelectChange}
        >
          {statusOptions
            .filter(s => s.value !== '')
            .map(option => (
              <MenuItem key="status_true" value={option.value}>
                {option.name}
              </MenuItem>
            ))}
        </Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDelete} color="primary">
          {t('app.common.delete')}
        </Button>
        <Button fullWidth onClick={handleClose} color="primary">
          {manufacturerStrings.cancel}
        </Button>
        <Button
          onClick={onClickSaveEquipmentCategory}
          fullWidth
          variant="contained"
          color="secondary"
        >
          {manufacturerStrings.save}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
